import React from "react";

function CalendarMockup() {
  const hours = ["9 AM", "10 AM", "11 AM", "12 PM", "1 PM"];
  const days = ["Mon", "Tue", "Wed", "Thu", "Fri"];

  return (
    <div className="bg-warm-bg-card border border-warm-border rounded-2xl shadow-soft-lg overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-warm-border bg-warm-bg-elevated">
        <span className="text-xs font-semibold text-warm-text-primary">March 2026</span>
        <div className="flex gap-1">
          <span className="text-[10px] px-2 py-0.5 rounded bg-warm-blue text-white font-medium">Week</span>
          <span className="text-[10px] px-2 py-0.5 rounded text-warm-text-tertiary">Day</span>
        </div>
      </div>

      {/* Day headers */}
      <div className="grid grid-cols-[40px_repeat(5,1fr)] border-b border-warm-border">
        <div />
        {days.map((d) => (
          <div key={d} className="text-center py-2 text-[10px] font-medium text-warm-text-secondary">
            {d}
          </div>
        ))}
      </div>

      {/* Time grid */}
      <div className="grid grid-cols-[40px_repeat(5,1fr)] relative" style={{ minHeight: 200 }}>
        {hours.map((h) => (
          <React.Fragment key={h}>
            <div className="text-[9px] text-warm-text-tertiary pr-2 text-right py-3 border-b border-warm-border-subtle">
              {h}
            </div>
            {days.map((d) => (
              <div key={d} className="border-b border-l border-warm-border-subtle" style={{ minHeight: 40 }} />
            ))}
          </React.Fragment>
        ))}

        {/* Events */}
        <div
          className="absolute rounded text-[9px] text-white font-medium px-1.5 py-1 bg-warm-blue"
          style={{ top: 4, left: "calc(20% + 2px)", width: "calc(20% - 6px)", height: 72 }}
        >
          Design Review
        </div>
        <div
          className="absolute rounded text-[9px] text-white font-medium px-1.5 py-1 bg-emerald-500/80"
          style={{ top: 84, left: "calc(40% + 2px)", width: "calc(20% - 6px)", height: 36 }}
        >
          <span className="opacity-70">📅</span> Team Standup
        </div>
        <div
          className="absolute rounded text-[9px] text-white font-medium px-1.5 py-1"
          style={{
            top: 44,
            left: "calc(60% + 2px)",
            width: "calc(20% - 6px)",
            height: 52,
            backgroundColor: "var(--color-accent-violet)",
          }}
        >
          Sprint Planning
        </div>
        <div
          className="absolute rounded text-[9px] text-white font-medium px-1.5 py-1 bg-amber-500/80"
          style={{ top: 124, left: "calc(80% + 2px)", width: "calc(20% - 6px)", height: 36 }}
        >
          <span className="opacity-70">📅</span> 1:1 Meeting
        </div>
      </div>
    </div>
  );
}

export default CalendarMockup;